function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Exclamation Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.9639,0.5 C15.1829,0.5 19.4279,4.746 19.4279,9.964 C19.4279,15.183 15.1829,19.428 9.9639,19.428 C4.7459,19.428 0.4999,15.183 0.4999,9.964 C0.4999,4.746 4.7459,0.5 9.9639,0.5 Z M9.9639,1.5 C5.2969,1.5 1.4999,5.297 1.4999,9.964 C1.4999,14.631 5.2969,18.428 9.9639,18.428 C14.6309,18.428 18.4279,14.631 18.4279,9.964 C18.4279,5.297 14.6309,1.5 9.9639,1.5 Z M9.9639,14.2501 C10.3779,14.2501 10.7139,14.5861 10.7139,15.0001 C10.7139,15.4141 10.3779,15.7661 9.9639,15.7661 C9.5499,15.7661 9.2139,15.4461 9.2139,15.0321 L9.2139,15.0001 C9.2139,14.5861 9.5499,14.2501 9.9639,14.2501 Z M9.9639,4.5 C10.2399,4.5 10.4639,4.724 10.4639,5 L10.4639,11 C10.4639,11.276 10.2399,11.5 9.9639,11.5 C9.6879,11.5 9.4639,11.276 9.4639,11 L9.4639,5 C9.4639,4.724 9.6879,4.5 9.9639,4.5 Z",
  id: "exclamation-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "exclamation-Icon/Global/Alert",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "exclamation-Swatches/DarkGreen",
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "exclamation-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#exclamation-path-1"
})));

var SvgExclamation = function SvgExclamation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExclamation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exclamation.ff107216.svg";
export { ForwardRef as ReactComponent };